import { ReduxComponentInterface } from 'edocatbase/Global';
import { ControlInterface } from 'edocatbase/Form';
const { GridOn } = window.MaterialIcons;
const { Link, withStyles, FormHelperText } = window.Material;

const { toggleModal } = window.Edocat.Components.ModalTest.actions;
import TableInner from './TableInner';
import FormModal from './FormModal';
import { Dispatch } from 'redux';
import { extractNoderefsFromFormTableFieldDataJSON, substituteNodeRefsByLabel } from '../../../../../utils/tableAsyncCells';
import { fetchObjectsToCache } from '../../../../../actions/objectCache';
import { without } from 'ramda';


interface TableProps extends ReduxComponentInterface, ControlInterface {
	isTableModalOpen: boolean;
	formInstanceId: string;
	params: any;
	formModal: any;
	view: boolean;
	classes: any;
	error: any;
	mandatory: boolean;
	usedObjects: any;
}

const styles = {
	link: {
		display: 'flex',
		alignItems: 'center',
		cursor: 'pointer',
	},
	icon: {
		marginRight: '5px',
	},
};

class Table extends React.PureComponent<TableProps> {
	static defaultProps: {
		view: false;
	};

	componentDidMount(): void {
		const { actions, value, usedObjects } = this.props;
		const missing = without(Object.keys(usedObjects), extractNoderefsFromFormTableFieldDataJSON(value ?? []));
		if (missing.length > 0) {
			actions.fetchObjectsToCache(missing);
		}
	}

	onLinkClick = (event: React.MouseEvent) => {
		event.preventDefault();
		const { actions, name, formInstanceId } = this.props;
		actions.toggleModal(true, name, null, formInstanceId);
	};

	render() {
		const {
			label,
			name,
			formInstanceId,
			value,
			params,
			formModal,
			view,
			disabled,
			classes,
			error,
			mandatory,
			usedObjects,
		} = this.props;
		const err = error?.includes(name);

		const dislplayValues = substituteNodeRefsByLabel(value, params.tableHeaders, usedObjects);

		return (
			<div className={`form-row row-${name}`}>
				<TableInner {...{ name, value, wholeTableDislplayValues: dislplayValues, params, formInstanceId, view, label, error, mandatory }} />
				<FormHelperText error={error?true:false}>{error}</FormHelperText>
				{formModal?.isOpen && <FormModal {...{ name, value, dislplayValues, params, formModal, formInstanceId }} />}
			</div>
		);
	}
}

const mapStateToProps = (state: any, props: any) => {
	const formModal = state?.[props.formInstanceId]?.formModal?.[`form${props.name}`] || {};
	//const error = state?.[props.formInstanceId]?.form?.error;
	const mandatory = state?.[props.formInstanceId]?.form?.fields?.[props.name]?.mandatory;
	const usedObjects = state?.cacheReducer?.usedObjects || {};

	return {
		usedObjects,
		formModal,
		//error,
		mandatory,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: window.redux.bindActionCreators({ toggleModal, fetchObjectsToCache }, dispatch),
});

export default window.reactRedux.connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Table));
